import { KuxCategoryMetas, RatingProviderEnum } from '@kaltura-ott/tvpil';

export const ratingMetaKeys: { [key in RatingProviderEnum]: string } = {
  [RatingProviderEnum.imdb]: 'imdb-rating',
  [RatingProviderEnum.o2]: 'o2-rating',
  [RatingProviderEnum.kp]: 'KpRating',
  [RatingProviderEnum.tvprofi]: 'tvprofi-rating',
  [RatingProviderEnum.star]: 'star_rating',
  [RatingProviderEnum.serialzone]: 'serialzone-rating',
};

export interface RatingInfo {
  ratingProvider: string;
  presentRatingSourceLogo: boolean;
  stars: string;
}

const PROGRAM_META_MAX_RATES = 3;

/**
 * @deprecated
 */
export const getAllRates = <T extends { metas: KuxCategoryMetas }>(
  { metas }: T,
  limit = PROGRAM_META_MAX_RATES,
): RatingInfo[] => {
  const ratings: RatingInfo[] = [];
  Object.entries(ratingMetaKeys).forEach(([ratingProvider, metaKey]) => {
    const rate = metas[metaKey];
    const stars = rate ? String(rate) : undefined;
    if (stars) {
      ratings.push({
        ratingProvider: ratingProvider,
        presentRatingSourceLogo: true,
        stars,
      });
    }
  });
  return ratings.slice(0, limit);
};
